import React from "react";

const stageColors = stageValue => {
  const stage = String(stageValue || "").toLowerCase();

  if (stage.includes("reject")) {
    return { bg: "#fee2e2", color: "#991b1b", accent: "#ef4444" };
  }

  if (stage.includes("offer") || stage.includes("placed") || stage.includes("selected")) {
    return { bg: "#dcfce7", color: "#166534", accent: "#22c55e" };
  }

  if (stage.includes("interview") || stage.includes("round")) {
    return { bg: "#dbeafe", color: "#1d4ed8", accent: "#3b82f6" };
  }

  if (stage.includes("screen") || stage.includes("assessment")) {
    return { bg: "#fef3c7", color: "#92400e", accent: "#f59e0b" };
  }

  return { bg: "#eef2ff", color: "#4338ca", accent: "#6366f1" };
};

const getItemValue = (item, keys, fallback = "-") => {
  for (const key of keys) {
    if (item?.[key] !== undefined && item?.[key] !== null && item?.[key] !== "") {
      return item[key];
    }
  }

  return fallback;
};

const PipelineHistoryTimeline = ({ items = [], emptyMessage = "No pipeline history available." }) => {
  if (!Array.isArray(items) || items.length === 0) {
    return (
      <div
        className="text-center"
        style={{
          padding: "2rem 1rem",
          color: "#64748b",
          background: "#f8fafc",
          border: "1px dashed #cbd5e1",
          borderRadius: 12,
        }}
      >
        {emptyMessage}
      </div>
    );
  }

  return (
    <div style={{ position: "relative", display: "grid", gap: 14, paddingLeft: 34 }}>
      <div
        style={{
          position: "absolute",
          left: 12,
          top: 8,
          bottom: 8,
          width: 2,
          background: "linear-gradient(180deg, #93c5fd, #dbeafe)",
          borderRadius: 999,
        }}
      />
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;
        const stage = getItemValue(item, ["stage", "to_stage"], "--");
        const colors = stageColors(stage);
        const title = getItemValue(item, ["jobTitle", "job_title", "title"], "-");
        const reason = getItemValue(item, ["reason"], "");
        const updatedBy = getItemValue(item, ["updatedBy", "updated_by", "changed_by", "createdBy", "created_by"], "--");
        const updatedAt = getItemValue(item, ["updatedAt", "updated_at", "changed_at", "timestamp"], "--");

        return (
          <div
            key={`${stage}-${updatedAt}-${index}`}
            style={{
              position: "relative",
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr)",
              columnGap: 16,
              rowGap: 12,
              alignItems: "start",
              background: "#ffffff",
              border: "1px solid #dbe3ef",
              borderRadius: 12,
              padding: "14px 16px 14px 18px",
              boxShadow: "0 8px 20px rgba(15, 23, 42, 0.06)",
            }}
          >
            <span
              style={{
                position: "absolute",
                left: -29,
                top: 23,
                width: 14,
                height: 14,
                borderRadius: "50%",
                background: isCurrent ? "#2563eb" : colors.accent,
                border: "3px solid #fff",
                boxShadow: "0 0 0 4px #dbeafe",
              }}
            />
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "minmax(0, 1fr) max-content",
                  alignItems: "center",
                  columnGap: 14,
                  marginBottom: 12,
                  minWidth: 0,
                }}
              >
                <span
                  style={{
                    justifySelf: "start",
                    borderRadius: 999,
                    padding: "6px 13px",
                    fontSize: 13,
                    fontWeight: 600,
                    background: isCurrent ? "#e0f2fe" : colors.bg,
                    color: isCurrent ? "#0369a1" : colors.color,
                    whiteSpace: "nowrap",
                  }}
                >
                  {isCurrent ? "Current Stage : " : "Stage : "}
                  {stage || "--"}
                </span>

                <div
                  style={{
                    color: "#334155",
                    fontSize: 13,
                    fontWeight: 500,
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: 8,
                    padding: "7px 11px",
                    whiteSpace: "nowrap",
                  }}
                >
                  {updatedAt}
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: reason ? "minmax(0, 1fr) minmax(0, 1fr)" : "minmax(0, 1fr)",
                  gap: 12,
                }}
              >
                {reason && (
                  <div
                    style={{
                      minWidth: 0,
                      background: "#f8fafc",
                      border: "1px solid #e5e7eb",
                      borderRadius: 9,
                      padding: "8px 11px",
                    }}
                  >
                    <div style={{ color: "#64748b", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>
                      Reason
                    </div>
                    <div
                      style={{
                        color: "#1f2937",
                        fontSize: 14,
                        fontWeight: 500,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={reason}
                    >
                      {reason}
                    </div>
                  </div>
                )}

                <div
                  style={{
                    minWidth: 0,
                    background: "#f8fafc",
                    border: "1px solid #e5e7eb",
                    borderRadius: 9,
                    padding: "8px 11px",
                  }}
                >
                  <div style={{ color: "#64748b", fontSize: 12, fontWeight: 600, marginBottom: 4 }}>
                    Updated By
                  </div>
                  <div
                    style={{
                      color: "#1f2937",
                      fontSize: 14,
                      fontWeight: 500,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={updatedBy}
                  >
                    {updatedBy}
                  </div>
                </div>
              </div>
            </div>

          </div>
        );
      })}
    </div>
  );
};

export default PipelineHistoryTimeline;
